import { atom } from 'recoil'
import { FileType } from 'yolda-web-ui'
import { SelectedType } from 'yolda-web-ui/dist/components/Select/Select.types'

export type AuthAtomType = {
  agreements: Record<string, boolean>
  agreementList: Record<string, any>[]
  country: string
  phoneNumber?: string
  otp: string
  name: string
  familyName: string
  companyTitle: string
  email?: string
  signInPassword?: string
  password?: string
  confirmPassword?: string
  forgotPasswordCode?: string
  vatId?: string
  taxId?: string
  financialMail?: string
  insuranceDocument?: FileType | null
  insuranceValidDate?: Date | null
  taxLicenseDocument?: FileType | null
  taxLicenseValidDate?: Date | null
  freightLicenseDocument?: FileType | null
  freightLicenseType?: SelectedType
  freightLicenseValidDate?: Date | null
  externalCountry?: string
}

export const DEFAULT_STATE = {
  agreements: {
    user: false,
    personal: false,
    commercial: false,
  },
  agreementList: [],
  country: '',
  phoneNumber: '',
  otp: '',
  name: '',
  companyTitle: '',
  familyName: '',
  email: '',
  signInPassword: '',
  password: '',
  confirmPassword: '',
  forgotPasswordCode: '',
  vatId: '',
  taxId: '',
  financialMail: '',
  insuranceDocument: null,
  insuranceValidDate: null,
  taxLicenseDocument: null,
  taxLicenseValidDate: null,
  freightLicenseDocument: null,
  freightLicenseType: '',
  freightLicenseValidDate: null,
  externalCountry: '',
}

export const authAtom = atom<AuthAtomType>({
  key: 'authState',
  default: DEFAULT_STATE,
})

export type AuthAtomTypeKeys = Readonly<
  | 'agreements'
  | 'country'
  | 'phoneNumber'
  | 'otp'
  | 'name'
  | 'familyName'
  | 'companyTitle'
  | 'email'
  | 'signInPassword'
  | 'password'
  | 'confirmPassword'
  | 'forgotPasswordCode'
  | 'country'
  | 'vatId'
  | 'taxId'
  | 'financialMail'
  | 'insuranceDocument'
  | 'insuranceValidDate'
  | 'taxLicenseDocument'
  | 'taxLicenseValidDate'
  | 'freightLicenseDocument'
  | 'freightLicenseType'
  | 'freightLicenseValidDate'
  | 'externalCountry'
>
